/**
 * The `StepTimeline` component in React creates a step-by-step timeline with navigation buttons to
 * move between steps.
 * @returns The `StepTimeline` component is being returned. It is a functional component that renders a
 * step timeline with sidebar and content sections. The component takes `steps` and `onComplete` as
 * props, where `steps` is an array of objects representing each step in the timeline. The component
 * uses state to keep track of the current step being displayed.
 */
import React, { useState } from 'react';
import { Button, Typography } from 'antd';
import { Card } from 'soxo-bootstrap-core';
import './step-timeline.scss';

const StepTimeline = ({ steps = [], onComplete }) => {
    const [current, setCurrent] = useState(0);
    const { Title, Text } = Typography;

    const next = async () => {
  const step = steps[current];
  if (step?.apiCall) {
    try {
      await step.apiCall();
    } catch {
      return; // stay on current step if validation fails
    }
  }
  if (current < steps.length - 1) setCurrent(current + 1);
  else onComplete?.();
};

    // const next = () => {
    //     if (current < steps.length - 1) {
    //         setCurrent(current + 1);
    //     } else {
    //         onComplete?.();
    //     }
    // };

    const prev = () => {
        if (current > 0) setCurrent(current - 1);
    };

    return (
        <div className="step-timeline-container">
            {/* step time line sidebar */}
            <div className="timeline-sidebar">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`timeline-step ${index === current ? 'active' : index < current ? 'completed' : ''}`}
                        onClick={() => setCurrent(index)}
                    >
                        <div className="step-marker">
                            <div className="step-number">{index + 1}</div>
                            {index < steps.length - 1 && <div className="vertical-line" />}
                        </div>

                        <div className="step-info">
                            <Text className="step-title">Step {index + 1}</Text>
                            <Title level={5} className="step-main">
                                {step.title}
                            </Title>
                            <Text className="step-desc">{step.description}</Text>
                        </div>
                    </div>
                ))}
            </div>

            {/* step-time line content */}
            <div className="timeline-content">
                <Card className="content-card">
                    <div className="content-body">
                        <Title level={5}>{steps[current]?.title}</Title>
                        <Text type="secondary">{steps[current]?.description}</Text>
                        <div style={{ marginTop: 16 }}>{steps[current]?.content || <p>No content</p>}</div>
                    </div>

                    <div className="step-actions">
                        {current > 0 && <Button onClick={prev}>Previous</Button>}
                        <Button type="primary" onClick={next}>
                            {current === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default StepTimeline;
